import React, { useEffect, useState } from "react";

import Spinner from "../../../components/helpers/Spinner";
import { useAppSelector } from "../../../hooks/hooks";

import { fetchAxiosNoToken } from "../../../helpers/fetchAxiosNoToken";
import { Selected } from "../../dashboardPropietarios/calendario/ModalEditVariablePrice";
import { Paginado } from "../../../components/Paginado";
import { NavbarHotel } from "../NavbarHotel";
import { NavbarMobileHotel } from "../NavbarMobileHotel";
import { ModalEditVariablePrice } from "../calendario/ModalEditVariablePrice";

export interface GetAllHabitacionesGlobal {
    totalItems: number;
    data: TipoHabitacion[];
}

export interface TipoHabitacion {
    id: number;
    nombre: string;
    habitaciones: Habitacion[];
}

export interface Habitacion {
    id: number;
    nombre: string;
    banner: string;
    terminado: string;
    precio_base: string;
    personas: string;
    id_tipo_hotel_habitaciones: number;
    estado_limpieza: EstadoLimpieza;
    disponibilidades: Disponibilidades;
    pedidos: Pedidos;

    habitacion: Casa;
    precios_variables: VariablePrice[];
}
export interface PedidoDia {
    id_pedido: number;
    fecha: string;
    is_paid: boolean;
    cliente: string;
}
export interface Pedidos {
    arrayFechasPedido: PedidoDia[];
}

export interface DisponibilidadCasas {
    id: number;
    nombre: string;
    banner: string;
    terminado: string;
    precio_base: string;
    tipo_moneda: string;
    personas: number;
    clave: string;
    id_airbnb: string;
    id_booking: string;
    disponibilidades: Disponibilidades;
    pedidos: Pedidos;
    fechas_externas: FechasExternas;
    casa: Casa;
    precios_variables: VariablePrice[];
}

interface VariablePrice {
    id: number;
    id_habitacion: number;
    fecha: string;
    precio: string;
}
export interface Casa {
    precio_base: string;
    tipo_moneda: string;
}

export interface Disponibilidades {
    arrayDias: ArrayDia[];
    arrayFechas: ArrayFecha[];
}

enum EstadoLimpieza {
    LIMPIA = "Limpia",
    SUCIA = "Sucia",
    LIMPIANDO = "Limpiando",
}

export interface ArrayDia {
    dia: number;
    fecha_inicio: string;
    fecha_final: string;
}

export interface ArrayFecha {
    fecha: string;
    motivo: string;
}

export interface FechasExternas {
    disponibilidadBC: DisponibilidadBc;
    disponibilidadAirBnb: DisponibilidadAirBnb;
    disponibilidadBooking: DisponibilidadBooking;
}

export interface DisponibilidadBc {
    arrayDias: any[];
    arrayMeses: any[];
    arrayFechas: string[];
    pedidos: any[];
}

export interface DisponibilidadAirBnb {
    arrayFechas: string[];
}

export interface DisponibilidadBooking {
    arrayFechas: string[];
}

const CalendarioHabitaciones = () => {
    const [cargando, setCargando] = useState(true);
    const [nombre, setNombre] = useState("");
    const [total, setTotal] = useState(0);
    const [pagina, setpagina] = useState(1);
    const [page, setPage] = useState(new Date().getMonth() + 1);
    const [prev, setPrev] = useState(0);
    const [pageAño, setPageAño] = useState(new Date().getFullYear());
    const [mesArray, setMesArray] = useState<any[]>([]);
    const [modalVisiblePrice, setModalVisiblePrice] = useState<boolean>(false);
    const [idCasaSelect, setIdCasaSelect] = useState<number>(0);
    const [precioBaseSelect, setPrecioBaseSelect] = useState<string>("");
    const CASAS_PAGE = 8;
    const [variablePrice, setVariablePrice] = useState<VariablePrice[]>([]);
    const [tipos, setTipos] = useState<TipoHabitacion[]>([]);
    const [expanded, setExpanded] = useState<Set<number>>(new Set());

    const [selected, setSelected] = useState<Selected>({
        date: "",
        price: "",
        fechaNoDisponible: false,
    });

    const [fechasSeleccionadas, setFechasSeleccionadas] = useState({
        fecha_inicio: "",
        fecha_final: "",
    });

    const [disponibilidadCasas, setDisponibilidadCasas] = useState<
        DisponibilidadCasas[]
    >([]);
    const { id } = useAppSelector((state) => state.landing_house.house);

    let hoy = new Date();

    let mesLetra = [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre",
    ];
    const [personas, setPersonas] = useState<number>(0);
    const [ocupacion, setOcupacion] = useState<Record<string, number>>({});
    const token = localStorage.getItem("token");
    const headers = {
        authorization: token,
    };

    const getBadgeClass = (estado: EstadoLimpieza) => {
        switch (estado) {
            case EstadoLimpieza.LIMPIA:
                return "bg-green-100 text-green-700 border-green-300";
            case EstadoLimpieza.SUCIA:
                return "bg-red-100 text-red-700 border-red-300";
            case EstadoLimpieza.LIMPIANDO:
                return "bg-yellow-100 text-yellow-700 border-yellow-300";
            default:
                return "bg-gray-100 text-gray-700 border-gray-300";
        }
    };

    const getAllDisponibilidades = async (
        pageNumber: number,
        search: string,
        personas: number,
        mes: number,
        ano: number,
        limpiarFechas = false,
    ) => {
        setCargando(true);
        setTipos([]);
        setTotal(0);

        const data = await fetchAxiosNoToken({
            url: `/hotel_habitaciones/getAllHabitacionesGlobal/${id}?search=${encodeURIComponent(
                search || "",
            )}&personas=${personas}&mes=${mes}&anio=${ano}&fecha_inicio=${
                limpiarFechas ? "" : fechasSeleccionadas.fecha_inicio
            }&fecha_final=${
                limpiarFechas ? "" : fechasSeleccionadas.fecha_final
            }`,
        });
        console.log("data", data);
        setTotal(data.totalItems || 0);
        setTipos(data.data || []);
        setOcupacion(data.ocupacion || {});
        setPage(data.month || new Date().getMonth() + 1);
        setPageAño(data.year || new Date().getFullYear());
        setTimeout(() => setCargando(false), 1000);
    };

    const pagination = (pageNumber: number) => {
        setpagina(pageNumber);
        getAllDisponibilidades(pageNumber, nombre, personas, page, pageAño);
    };

    useEffect(() => {
        getAllDisponibilidades(pagina, nombre, personas, page, pageAño);
    }, [personas, id]);

    useEffect(() => {
        if (!modalVisiblePrice) {
            getAllDisponibilidades(pagina, nombre, personas, page, pageAño);
            setSelected({
                date: "",
                price: "",
                fechaNoDisponible: false,
            });
            setPrecioBaseSelect("");
            setIdCasaSelect(0);
        }
    }, [modalVisiblePrice]);

    const getPrecio = (
        variablePrice: VariablePrice[],
        precioBase: string,
        diaDelMes: number,
    ) => {
        const dia = `${pageAño}-${page < 10 ? `0${page}` : page}-${
            diaDelMes < 10 ? `0${diaDelMes}` : diaDelMes
        }`;
        const found = variablePrice.find((x) => x.fecha === dia);
        return found ? found.precio : precioBase;
    };

    const colorDia = (
        disponibilidad: Disponibilidades,
        diaDelMes: number,
        pedidos: Pedidos,
    ) => {
        const dias = disponibilidad.arrayDias || [];
        const fechas = disponibilidad.arrayFechas || [];

        const diaISO = `${pageAño}-${page < 10 ? `0${page}` : page}-${
            diaDelMes < 10 ? `0${diaDelMes}` : diaDelMes
        }`;

        if (hayReservaEnDia(pedidos, diaISO))
            return "bg-blue-100  cursor-pointer";

        if (fechas.find((f) => (f.fecha || "").substring(0, 10) === diaISO))
            return "bg-[#c5c5c5] line-through";

        const diaDate = new Date(`${page}/${diaDelMes}/${pageAño}`).getDay();
        const diaDeSemanaEnRango = dias.some((d) => {
            const fi = new Date(d.fecha_inicio);
            const ff = new Date(d.fecha_final);
            const fa = new Date(
                `${page}/${
                    diaDelMes < 10 ? `0${diaDelMes}` : diaDelMes
                }/${pageAño}`,
            );
            return fa >= fi && fa <= ff && d.dia === diaDate;
        });
        if (diaDeSemanaEnRango) return "bg-[#c5c5c5] line-through";

        return "white";
    };
    const handleInputChange = (e: any) => {
        setNombre(e.target.value);

        setTimeout(() => {
            getAllDisponibilidades(
                pagina,
                e.target.value,
                personas,
                page,
                pageAño,
            );
        }, 500);
    };

    const modalPrecio = (hab: Habitacion, dia: number) => {
        const precioBase = getPrecio(
            hab.precios_variables,
            hab.habitacion.precio_base,
            dia,
        );
        const diaISO = `${pageAño}-${page < 10 ? `0${page}` : page}-${
            dia < 10 ? `0${dia}` : dia
        }`;

        const fechaNoDisponible = hab.disponibilidades.arrayFechas.find(
            (x) => x.fecha === diaISO,
        );

        setIdCasaSelect(hab.id);
        setModalVisiblePrice(true);
        setPrecioBaseSelect(precioBase);
        setSelected({
            price: precioBase,
            date: diaISO,
            fechaNoDisponible: fechaNoDisponible ? fechaNoDisponible : false,
        });
    };

    const getCasa = () => {
        getAllDisponibilidades(pagina, nombre, personas, page, pageAño);
    };

    useEffect(() => {
        const diasMes = new Date(pageAño, page, 0).getDate();
        const arr: number[] = [];
        for (let i = 1; i <= diasMes; i++) arr.push(i);
        setMesArray(arr);

        getAllDisponibilidades(pagina, nombre, personas, page, pageAño);
    }, []);

    const getReservaDelDia = (pedidos: Pedidos, diaISO: string) => {
        return pedidos.arrayFechasPedido.find((p) => p.fecha === diaISO);
    };

    const hayReservaEnDia = (pedidos: Pedidos, diaISO: string) => {
        return pedidos.arrayFechasPedido.some((p) => p.fecha === diaISO);
    };

    const hayImpagoEnDia = (pedidos: Pedidos, diaISO: string) => {
        return pedidos.arrayFechasPedido.some(
            (p) => p.fecha === diaISO && !p.is_paid,
        );
    };

    const changeData = (mes: number, ano: number) => {
        const diasMes = new Date(ano, mes, 0).getDate();
        const arr: number[] = [];
        for (let i = 1; i <= diasMes; i++) arr.push(i);
        setMesArray(arr);

        getAllDisponibilidades(pagina, nombre, personas, mes, ano);
    };

    const prevDate = () => {
        if (page > 1) {
            setPage(page - 1);
            setPrev(prev - 1);
            changeData(page - 1, pageAño);
        } else {
            setPage(12);
            setPageAño(pageAño - 1);
            setPrev(prev - 1);
            changeData(12, pageAño - 1);
        }
    };

    const nextDate = () => {
        if (page < 12) {
            setPage(page + 1);
            setPrev(prev + 1);
            changeData(page + 1, pageAño);
        } else {
            setPage(1);
            setPageAño(pageAño + 1);
            setPrev(prev + 1);
            changeData(1, pageAño + 1);
        }
    };

    const hoyDate = () => {
        setPage(new Date().getMonth() + 1);
        setPageAño(new Date().getFullYear());
        setPrev(0);

        changeData(new Date().getMonth() + 1, new Date().getFullYear());
    };

    const setLimparFechas = () => {
        setPage(new Date().getMonth() + 1);
        setPageAño(new Date().getFullYear());
        setPrev(0);

        getAllDisponibilidades(
            pagina,
            nombre,
            personas,
            new Date().getMonth() + 1,
            new Date().getFullYear(),
            true,
        );
    };

    return (
        <NavbarHotel titulo="Calendario">
            {selected.price !== "" && (
                <ModalEditVariablePrice
                    idCasa={idCasaSelect || 0}
                    modalVisiblePrice={modalVisiblePrice}
                    setModalVisiblePrice={setModalVisiblePrice}
                    moneda={precioBaseSelect}
                    setVariablePrice={setVariablePrice}
                    selected={selected}
                    getCasa={getCasa}
                />
            )}
            <div className="w-full">
                <div className="px-4 my-3">
                    <div className="mt-10">
                        <div
                            className={
                                "grid grid-cols-1 justify-items-center md:justify-items-start   w-[95%] mx-auto mt-4"
                            }
                        >
                            <div className="flex items-center gap-5">
                                <div className="flex w-full p-1 mr-2 border-2 border-[#CCCCCC] rounded-lg appearance-none md:w-80 left-2 text-stone-900">
                                    <button className="flex items-center justify-center px-2">
                                        <svg
                                            className="2xl:w-6 2xl:h-6 w-5 h-5 text-[#808080]"
                                            fill="currentColor"
                                            viewBox="0 0 24 24"
                                        >
                                            <path d="M16.32 14.9l5.39 5.4a1 1 0 0 1-1.42 1.4l-5.38-5.38a8 8 0 1 1 1.41-1.41zM10 16a6 6 0 1 0 0-12 6 6 0 0 0 0 12z"></path>
                                        </svg>
                                    </button>{" "}
                                    <input
                                        onBlur={() => setNombre("")}
                                        value={nombre}
                                        type="text"
                                        onChange={handleInputChange}
                                        className="w-full bg-transparent outline-none appearance-none 2xl:py-2 placeholder:text-[#808080]"
                                        placeholder="Buscar"
                                    />
                                </div>

                                <div className="flex flex-col items-center gap-3">
                                    <h2 className="font-semibold text-stone-900 whitespace-nowrap">
                                        Buscar habitaciones por disponibilidad
                                    </h2>
                                    <div className="flex gap-2">
                                        <input
                                            type="date"
                                            value={
                                                fechasSeleccionadas.fecha_inicio
                                            }
                                            onChange={(e) =>
                                                setFechasSeleccionadas({
                                                    ...fechasSeleccionadas,
                                                    fecha_inicio:
                                                        e.target.value,
                                                })
                                            }
                                            className="border border-[#CCCCCC] rounded-lg px-2 py-1 text-stone-900"
                                        />
                                        <input
                                            type="date"
                                            value={
                                                fechasSeleccionadas.fecha_final
                                            }
                                            onChange={(e) =>
                                                setFechasSeleccionadas({
                                                    ...fechasSeleccionadas,
                                                    fecha_final: e.target.value,
                                                })
                                            }
                                            className="border border-[#CCCCCC] rounded-lg px-2 py-1 text-stone-900"
                                        />
                                    </div>

                                    <div className="flex items-center justify-end w-full gap-2">
                                        <div
                                            onClick={() => {
                                                setFechasSeleccionadas({
                                                    fecha_inicio: "",
                                                    fecha_final: "",
                                                });
                                                setLimparFechas();
                                            }}
                                            className="px-4 py-2 border rounded-lg cursor-pointer border-blue-blueFrom text-blue-blueFrom hover:scale-105"
                                        >
                                            Limpiar fechas
                                        </div>
                                        <button
                                            onClick={() => {
                                                getAllDisponibilidades(
                                                    pagina,
                                                    nombre,
                                                    personas,
                                                    0,
                                                    pageAño,
                                                );
                                            }}
                                            className="px-4 py-2 bg-[#029BFC] text-white rounded-lg hover:scale-105 cursor-pointer"
                                        >
                                            Buscar
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="flex items-center mt-4">
                                <p className="mr-2">Personas</p>
                                <select
                                    value={personas}
                                    onChange={(e) =>
                                        setPersonas(Number(e.target.value))
                                    }
                                    className="pl-1 py-1 border-2 border-[#CCCCCC] rounded-lg "
                                >
                                    <option value={"0"}>Seleccionar</option>
                                    {Array.from(
                                        { length: 100 },
                                        (_, index) => index + 1,
                                    ).map((number) => (
                                        <option key={number} value={number}>
                                            {number}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className="text-center mt-7 font-semibold text-lg lg:text-3xl md:text-2xl w-[95%] mx-auto py-2   bg-[#029BFC] text-white rounded-lg ">
                        {mesLetra[page - 1]}
                    </div>
                </div>
                {!cargando && id ? (
                    <div>
                        <div>
                            <nav className="container flex justify-between  w-[95%] mx-auto select-none mb-2">
                                <div className="flex justify-between max-w-3xl pl-2 mt-8 ">
                                    <ul className="inline-flex ">
                                        <li
                                            onClick={() => {
                                                if (prev !== 0) {
                                                    prevDate();
                                                }
                                            }}
                                            className={`lex items-center  hover:bg-slate-100 ${
                                                prev === 0
                                                    ? "cursor-not-allowed"
                                                    : "cursor-pointer"
                                            }`}
                                        >
                                            <svg
                                                className={`h-8 w-8 p-0.5 
                                                    ${
                                                        prev === 0
                                                            ? "text-gray-400 "
                                                            : "text-[#029BFC] border-[#029BFC]"
                                                    }
                                                     border  mx-1 rounded-lg`}
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                strokeWidth="2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            >
                                                {" "}
                                                <polyline points="15 18 9 12 15 6" />
                                            </svg>
                                        </li>

                                        <li
                                            className={`bg-[#029BFC] text-white font-semibold border-[#029BFC] hover:border-gray-200 px-3 text-lg border rounded-lg  cursor-pointer
                                               
                                        `}
                                            onClick={() => {
                                                hoyDate();
                                            }}
                                        >
                                            <span>{"Hoy"} </span>
                                        </li>

                                        <li
                                            onClick={() => {
                                                nextDate();
                                            }}
                                            className="flex items-center cursor-pointer hover:bg-slate-100"
                                        >
                                            <svg
                                                className="h-8 w-8 p-0.5 text-[#029BFC] border rounded-lg border-[#029BFC] mx-1"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                strokeWidth="2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            >
                                                {" "}
                                                <polyline points="9 18 15 12 9 6" />
                                            </svg>
                                        </li>
                                    </ul>
                                </div>
                            </nav>
                        </div>
                        <div
                            className={`container flex items-center ${
                                true ? "justify-center" : "justify-between"
                            }  w-[95%] mx-auto`}
                        ></div>
                        <div className=" w-[95%] mx-auto ">
                            <table className="w-full table-auto ">
                                <thead>
                                    <tr className="text-center">
                                        <th className="min-w-[150px] text-sm font-bold border border-[#E9E9E9] py-2 px-4 bg-[#029BFC] text-white">
                                            Fecha
                                        </th>
                                        {mesArray?.map((dia, i) => {
                                            const fecha = new Date(
                                                pageAño,
                                                page - 1,
                                                dia,
                                            );
                                            const diaSemana = fecha
                                                .toLocaleDateString("es-ES", {
                                                    weekday: "short",
                                                })
                                                .toUpperCase()
                                                .slice(0, 3);

                                            const esHoy =
                                                hoy.getDate() === dia &&
                                                page === hoy.getMonth() + 1 &&
                                                pageAño === hoy.getFullYear();

                                            return (
                                                <th
                                                    key={`fecha-${i}`}
                                                    className={`text-sm font-medium text-[#3C3C3C] border-y border-r border-[#E9E9E9] p-2 ${
                                                        esHoy
                                                            ? "bg-[#F7DC6F]"
                                                            : "bg-white"
                                                    }`}
                                                >
                                                    <div className="flex flex-col items-center">
                                                        <span className="font-bold">
                                                            {dia < 10
                                                                ? `0${dia}`
                                                                : dia}
                                                        </span>
                                                        <span className="text-[10px] text-gray-600">
                                                            {diaSemana}
                                                        </span>
                                                    </div>
                                                </th>
                                            );
                                        })}
                                    </tr>

                                    <tr className="text-center">
                                        <th className="min-w-[150px] text-sm font-bold border border-[#E9E9E9] py-2 px-4 bg-[#029BFC] text-white">
                                            Ocupabilidad
                                        </th>
                                        {mesArray?.map((dia, i) => {
                                            const diaISO = `${pageAño}-${
                                                page < 10 ? `0${page}` : page
                                            }-${dia < 10 ? `0${dia}` : dia}`;
                                            const porcOcup =
                                                ocupacion?.[diaISO];

                                            return (
                                                <th
                                                    key={`ocup-${i}`}
                                                    className="text-sm font-medium text-[#3C3C3C] border-y border-r border-[#E9E9E9] p-2 bg-white"
                                                >
                                                    <span className="text-[10px] text-gray-500">
                                                        {typeof porcOcup ===
                                                        "number"
                                                            ? `${porcOcup}%`
                                                            : ""}
                                                    </span>
                                                </th>
                                            );
                                        })}
                                    </tr>

                                    <tr className="text-center">
                                        <th className="min-w-[150px] text-sm font-bold border border-[#E9E9E9] py-2 px-4 bg-[#029BFC] text-white">
                                            Habitaciones
                                        </th>
                                        {mesArray?.map((_, i) => (
                                            <th
                                                key={`habit-${i}`}
                                                className="text-sm font-medium text-[#3C3C3C] border-y  border-[#E9E9E9] p-2 bg-white"
                                            ></th>
                                        ))}
                                    </tr>
                                </thead>

                                {
                                    <tbody>
                                        {tipos.map((tipo) => {
                                            const isOpen = expanded.has(
                                                tipo.id,
                                            );
                                            return (
                                                <React.Fragment key={tipo.id}>
                                                    <tr
                                                        className="cursor-pointer select-none"
                                                        onClick={() => {
                                                            const next =
                                                                new Set(
                                                                    expanded,
                                                                );
                                                            if (
                                                                next.has(
                                                                    tipo.id,
                                                                )
                                                            )
                                                                next.delete(
                                                                    tipo.id,
                                                                );
                                                            else
                                                                next.add(
                                                                    tipo.id,
                                                                );
                                                            setExpanded(next);
                                                        }}
                                                    >
                                                        <td
                                                            className="px-2 py-3 font-semibold border-b border-x border-[#E9E9E9] bg-slate-50"
                                                            colSpan={
                                                                mesArray.length +
                                                                1
                                                            }
                                                        >
                                                            <div className="flex items-center justify-between">
                                                                <div className="flex items-center gap-1">
                                                                    <svg
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                        className={`w-4 h-4 transition-transform duration-200 ${
                                                                            isOpen
                                                                                ? "rotate-90"
                                                                                : "rotate-0"
                                                                        }`}
                                                                        fill="none"
                                                                        viewBox="0 0 24 24"
                                                                        stroke="currentColor"
                                                                        strokeWidth={
                                                                            2
                                                                        }
                                                                    >
                                                                        <path
                                                                            strokeLinecap="round"
                                                                            strokeLinejoin="round"
                                                                            d="M9 5l7 7-7 7"
                                                                        />
                                                                    </svg>
                                                                    <span>
                                                                        {
                                                                            tipo.nombre
                                                                        }{" "}
                                                                        (
                                                                        {
                                                                            tipo
                                                                                .habitaciones
                                                                                .length
                                                                        }
                                                                        )
                                                                    </span>
                                                                </div>
                                                                <span className="text-sm text-gray-500">
                                                                    {isOpen
                                                                        ? "Ocultar"
                                                                        : "Ver habitaciones"}
                                                                </span>
                                                            </div>
                                                        </td>
                                                    </tr>

                                                    {isOpen &&
                                                        tipo.habitaciones.map(
                                                            (hab) => (
                                                                <tr
                                                                    key={hab.id}
                                                                >
                                                                    <td className="px-2 py-2 text-sm border-b border-x border-[#E9E9E9]">
                                                                        <div className="flex items-center justify-between">
                                                                            <div>
                                                                                {
                                                                                    hab.nombre
                                                                                }
                                                                                <span className="block text-xs text-gray-400">
                                                                                    Personas
                                                                                    max:{" "}
                                                                                    {
                                                                                        hab.personas
                                                                                    }
                                                                                </span>
                                                                            </div>
                                                                            <div
                                                                                className={` px-3 py-1 text-xs font-bold rounded-full border shadow-sm z-10 ${getBadgeClass(hab.estado_limpieza)}`}
                                                                            >
                                                                                {
                                                                                    hab.estado_limpieza
                                                                                }
                                                                            </div>
                                                                        </div>
                                                                    </td>
                                                                    {mesArray.map(
                                                                        (
                                                                            dia,
                                                                            i,
                                                                        ) => {
                                                                            const diaISO = `${pageAño}-${
                                                                                page <
                                                                                10
                                                                                    ? `0${page}`
                                                                                    : page
                                                                            }-${
                                                                                dia <
                                                                                10
                                                                                    ? `0${dia}`
                                                                                    : dia
                                                                            }`;

                                                                            // buscamos si hay una reserva para este día
                                                                            const reserva =
                                                                                getReservaDelDia(
                                                                                    hab.pedidos,
                                                                                    diaISO,
                                                                                );

                                                                            if (
                                                                                reserva
                                                                            ) {
                                                                                // obtenemos todas las fechas de ese pedido
                                                                                const fechasDeEstePedido =
                                                                                    hab.pedidos.arrayFechasPedido.filter(
                                                                                        (
                                                                                            p,
                                                                                        ) =>
                                                                                            p.id_pedido ===
                                                                                            reserva.id_pedido,
                                                                                    );

                                                                                // checamos si este día es la primera fecha de ese pedido
                                                                                const primeraFecha =
                                                                                    fechasDeEstePedido[0]
                                                                                        .fecha;
                                                                                const isFirstDay =
                                                                                    reserva.fecha ===
                                                                                    primeraFecha;

                                                                                if (
                                                                                    !isFirstDay
                                                                                ) {
                                                                                    // si no es el inicio, no pintamos nada (porque ya está cubierto por colSpan)
                                                                                    return null;
                                                                                }

                                                                                // duración del bloque
                                                                                const duracion =
                                                                                    fechasDeEstePedido.length;

                                                                                const hayImpago =
                                                                                    hayImpagoEnDia(
                                                                                        hab.pedidos,
                                                                                        diaISO,
                                                                                    );

                                                                                return (
                                                                                    <td
                                                                                        key={
                                                                                            i
                                                                                        }
                                                                                        colSpan={
                                                                                            duracion
                                                                                        }
                                                                                        onClick={() =>
                                                                                            window.open(
                                                                                                `/dashboard-hotel/reservas/${reserva.id_pedido}`,
                                                                                                "_blank",
                                                                                            )
                                                                                        }
                                                                                        className="relative text-sm border-y border-r p-1 border-[#E9E9E9] bg-blue-200 text-center cursor-pointer"
                                                                                    >
                                                                                        <p className="text-xs font-bold truncate max-w-[70px] mx-auto">
                                                                                            {
                                                                                                reserva.cliente
                                                                                            }
                                                                                        </p>
                                                                                        <p className="text-[10px]">
                                                                                            #{" "}
                                                                                            {
                                                                                                reserva.id_pedido
                                                                                            }
                                                                                        </p>
                                                                                        {hayImpago && (
                                                                                            <span className="absolute inline-block w-2 h-2 bg-red-500 rounded-full top-1 right-1" />
                                                                                        )}
                                                                                    </td>
                                                                                );
                                                                            }

                                                                            // si no hay reserva → lógica normal
                                                                            const bg =
                                                                                colorDia(
                                                                                    hab.disponibilidades,
                                                                                    dia,
                                                                                    hab.pedidos,
                                                                                );
                                                                            const isToday =
                                                                                hoy.getDate() ===
                                                                                    dia &&
                                                                                page ===
                                                                                    hoy.getMonth() +
                                                                                        1 &&
                                                                                pageAño ===
                                                                                    hoy.getFullYear();
                                                                            const cellClass =
                                                                                bg ===
                                                                                "white"
                                                                                    ? isToday
                                                                                        ? "bg-[#F7DC6F] cursor-pointer hover:scale-110 hover:bg-slate-200"
                                                                                        : "bg-white cursor-pointer hover:scale-110 hover:bg-slate-200"
                                                                                    : bg;

                                                                            return (
                                                                                <td
                                                                                    key={
                                                                                        i
                                                                                    }
                                                                                    onClick={() => {
                                                                                        if (
                                                                                            bg ===
                                                                                            "white"
                                                                                        )
                                                                                            modalPrecio(
                                                                                                hab,
                                                                                                dia,
                                                                                            );
                                                                                    }}
                                                                                    className={`relative text-sm border-y border-r p-1 border-[#E9E9E9] ${cellClass}`}
                                                                                >
                                                                                    <p className="text-[8px] mx-auto text-center">
                                                                                        {
                                                                                            hab
                                                                                                .habitacion
                                                                                                .tipo_moneda
                                                                                        }
                                                                                    </p>
                                                                                    <p className="text-[10px]">
                                                                                        {getPrecio(
                                                                                            hab.precios_variables,
                                                                                            hab
                                                                                                .habitacion
                                                                                                .precio_base,
                                                                                            dia,
                                                                                        )}
                                                                                    </p>
                                                                                </td>
                                                                            );
                                                                        },
                                                                    )}
                                                                </tr>
                                                            ),
                                                        )}
                                                </React.Fragment>
                                            );
                                        })}
                                    </tbody>
                                }
                            </table>
                        </div>
                        <hr className="pl-4 mx-auto mt-12 border-white xs:hidden"></hr>
                        <div className="container flex items-center justify-between p-1 mx-auto">
                            <Paginado
                                elementsPerPage={CASAS_PAGE}
                                cantTotalElements={total}
                                pagination={pagination}
                                actualPage={pagina}
                            />
                        </div>
                    </div>
                ) : (
                    <div className="flex flex-col items-center justify-center w-full h-full ">
                        <p className="mb-2 text-xl font-medium">
                            Espere por favor, estamos cargando sus datos
                        </p>
                        <Spinner width={20} />
                    </div>
                )}
            </div>
            <NavbarMobileHotel />
        </NavbarHotel>
    );
};

export default CalendarioHabitaciones;
